import { useEffect, useRef } from 'react';
import './DragonPulseAnimation.css';

export default function DragonPulseAnimation({ onComplete, playerRef, opponentRef }) {
  const elementsRef = useRef([]);

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.parentElement;
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = pRect.left - cRect.left + pRect.width / 2;
    const startY = pRect.top - cRect.top + pRect.height / 2;
    const endX = oRect.left - cRect.left + oRect.width / 2;
    const endY = oRect.top - cRect.top + oRect.height / 2;

    const elements = [];

    // Phase 1: Charging Animation
    const chargeTime = 800;
    for (let i = 0; i < 3; i++) {
      const ring = document.createElement('div');
      ring.className = `dragon-pulse-charge-ring ring-${i}`;
      ring.style.left = `${startX}px`;
      ring.style.top = `${startY}px`;
      ring.style.animationDelay = `${i * 0.15}s`;
      container.appendChild(ring);
      elements.push(ring);
    }

    // Phase 2: Pulse Travel
    const travelTime = 500;
    const pulseTimer = setTimeout(() => {
      const pulse = document.createElement('div');
      pulse.className = 'dragon-pulse-main';
      pulse.style.left = `${startX}px`;
      pulse.style.top = `${startY}px`;
      pulse.style.setProperty('--tx', `${endX - startX}px`);
      pulse.style.setProperty('--ty', `${endY - startY}px`);
      container.appendChild(pulse);
      elements.push(pulse);
    }, chargeTime);

    // Phase 3: Impact
    const impactTime = chargeTime + travelTime;
    const impactTimer = setTimeout(() => {
      opponentEl.classList.add('dragon-pulse-hit');

      const impactBlast = document.createElement('div');
      impactBlast.className = 'dragon-pulse-impact';
      impactBlast.style.left = `${endX}px`;
      impactBlast.style.top = `${endY}px`;
      container.appendChild(impactBlast);
      elements.push(impactBlast);

      for (let i = 0; i < 15; i++) {
        const particle = document.createElement('div');
        particle.className = 'dragon-pulse-particle';
        particle.style.left = `${endX}px`;
        particle.style.top = `${endY}px`;
        const angle = Math.random() * 360;
        const distance = 80 + Math.random() * 40;
        particle.style.setProperty('--dx', `${Math.cos(angle * Math.PI / 180) * distance}px`);
        particle.style.setProperty('--dy', `${Math.sin(angle * Math.PI / 180) * distance}px`);
        particle.style.animationDelay = `${Math.random() * 0.1}s`;
        container.appendChild(particle);
        elements.push(particle);
      }
    }, impactTime);

    // Cleanup
    const cleanupTime = impactTime + 1200;
    const cleanupTimer = setTimeout(() => {
      elements.forEach(el => el.remove());
      opponentEl.classList.remove('dragon-pulse-hit');
      onComplete();
    }, cleanupTime);

    elementsRef.current = elements;

    return () => {
      clearTimeout(pulseTimer);
      clearTimeout(impactTimer);
      clearTimeout(cleanupTimer);
      elementsRef.current.forEach(el => el.remove());
      if (opponentEl) opponentEl.classList.remove('dragon-pulse-hit');
    };
  }, [onComplete, playerRef, opponentRef]);

  return null;
}

DragonPulseAnimation.moveType = 'dragon';
